import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { TradeWay } from 'models/TradeWay';
import { FC } from 'react';

const tradeWayAvailableValues: TradeWay[] = ['Buy', 'Sell'];

export interface TradeWayRadioButtonsProps {
  className?: string;
  tradeWay: TradeWay;
  isDisabled?: boolean;
  onSelect?(value: TradeWay): void;
}

export const TradeWayRadioButtons: FC<TradeWayRadioButtonsProps> = ({ className, tradeWay, isDisabled, onSelect }) => {
  const user = useIsInternalUser() ? 'internalUser' : 'externalUser';

  return (
    <ButtonsGroup
      isRadio
      className={className}
      isDisabled={isDisabled}
      items={tradeWayAvailableValues}
      selectedItems={tradeWay}
      translationPrefix={`form.buttons.${user}`}
      onSelect={items => onSelect && onSelect(items[0])}
    />
  );
};
